import cx from "classnames";
import dynamic from "next/dynamic";

import styles from "./styles.module.css";

const LogoLoader = dynamic(() => import("./Logo"));

export const LogoAnimated = ({ className }: { className?: string }) => {
  return (
    <div className={cx(styles.container, className)}>
      <LogoLoader className={styles.logo} />
    </div>
  );
};
